document.addEventListener("DOMContentLoaded", (evt) => {
	let contactForm = document.getElementById("contact-form") as HTMLFormElement;
	if (contactForm) {
		let storeToggle = contactForm.elements.namedItem("vb-store") as HTMLInputElement;
		let storeAddress = contactForm.elements.namedItem("vb-store_address") as HTMLTextAreaElement;
		storeAddress.disabled = !storeToggle.checked;
		storeToggle.addEventListener("change", (evt) => storeAddress.disabled = !storeToggle.checked);
	}
});
